export default {
      id: "long-arrow-usage",
      viewBox: "0 0 79 18",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#long-arrow",
      toString: function () {
        return this.url;
      }
    }